












































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import { bus } from "../../main";

@Component
export default class GiornoFogliFirmeCreate extends Vue {
	@Prop() params!: any;
	@Prop() info!: any;
	private enablePomeriggio: boolean;
	private enableMattino: boolean;
	private agree: boolean;

	private date: string;
	private dateTemp: string;
	private dateMenu: boolean;
	private startTimeMorning: any;
	private finishTimeMorning: any;
	private startTimeAfternoon: any;
	private finishTimeAfternoon: any;
	private finishTimeMenuMorning: boolean;
	private startTimeMenuMorning: boolean;
	private finishTimeMenuAfternoon: boolean;
	private startTimeMenuAfternoon: boolean;
	private totOre: number;

	private dateRules: [boolean | string];
	private startTimeMorningRules: [boolean | string];
	private finishTimeMorningRules: [boolean | string];
	private startTimeAfternoonRules: [boolean | string];
	private finishTimeAfternoonRules: [boolean | string];

	constructor() {
		super();
		this.enablePomeriggio = false;
		this.enableMattino = false;
		this.agree = false;
		this.date = "";
		this.dateTemp = new Date().toISOString().substr(0, 10);
		this.dateMenu = false;
		this.startTimeMorning = null;
		this.finishTimeMorning = null;
		this.startTimeAfternoon = null;
		this.finishTimeAfternoon = null;
		this.finishTimeMenuMorning = false;
		this.startTimeMenuMorning = false;
		this.finishTimeMenuAfternoon = false;
		this.startTimeMenuAfternoon = false;
		this.totOre = 0;

		this.dateRules = [true];
		this.startTimeMorningRules = [true];
		this.finishTimeMorningRules = [true];
		this.startTimeAfternoonRules = [true];
		this.finishTimeAfternoonRules = [true];
	}

	@Watch("dateTemp")
	onDateTempChange() {
		this.dateFilter();
		this.validazioneData();
	}

	@Watch("startTimeMorning")
	onStartTimeMorningChange() {
		this.timeMorningValidation();
	}

	@Watch("finishTimeMorning")
	onFinishTimeMorningChange() {
		this.timeMorningValidation();
	}

	@Watch("startTimeAfternoon")
	onStartTimeAfternoongChange() {
		this.timeMorningValidation();
		this.timeAfternoonValidation();
	}

	@Watch("finishTimeAfternoon")
	onFinishTimeAfternoonChange() {
		this.timeAfternoonValidation();
	}

	dateFilter() {
		const date = new Date(this.dateTemp);
		this.date = date.toLocaleString(["it-IT"], {
			day: "2-digit",
			month: "2-digit",
			year: "numeric"
		});
	}

	formatDate(dateString: string): string {
		if (!dateString) return '';
		const date = new Date(dateString);
		return date.toLocaleString(["it-IT"], {
			day: "2-digit",
			month: "2-digit",
			year: "numeric"
		});
	}

	timeMorningValidation() {
		if (this.startTimeMorning) {
			if (this.startTimeMorning > this.finishTimeMorning) {
				this.startTimeMorningRules = [
					"Orario inizio mattina maggiore di orario fine mattina"
				];
				this.finishTimeMorningRules = [
					"Orario fine mattina minore di orario inizio mattina"
				];
			} else {
				this.startTimeMorningRules = [true];
			}
		}
		if (this.finishTimeMorning) {
			if (this.finishTimeMorning < this.startTimeMorning) {
				this.finishTimeMorningRules = [
					"Orario fine mattina minore di orario inizio mattina"
				];
			} else {
				this.finishTimeMorningRules = [true];
			}
		}
		
		// Controllo sovrapposizione tra mattino e pomeriggio
		if (this.enablePomeriggio && this.enableMattino && this.finishTimeMorning && this.startTimeAfternoon) {
			if (this.finishTimeMorning >= this.startTimeAfternoon) {
				this.finishTimeMorningRules = [
					"L'orario fine mattina non può essere uguale o successivo all'orario inizio pomeriggio"
				];
				this.startTimeAfternoonRules = [
					"L'orario inizio pomeriggio deve essere successivo all'orario fine mattina"
				];
			}
		}
	}

	timeAfternoonValidation() {
		if (this.startTimeAfternoon) {
			if (this.startTimeAfternoon > this.finishTimeAfternoon) {
				this.startTimeAfternoonRules = [
					"Orario inizio pomeriggio maggiore di orario fine pomeriggio"
				];
				this.finishTimeAfternoonRules = [
					"Orario fine pomeriggio minore di orario inizio pomeriggio"
				];
			} else {
				this.startTimeAfternoonRules = [true];
			}
		}
		if (this.finishTimeAfternoon) {
			if (this.finishTimeAfternoon < this.startTimeAfternoon) {
				this.finishTimeAfternoonRules = [
					"Orario fine pomeriggio minore di orario inizio pomeriggio"
				];
			} else {
				this.finishTimeAfternoonRules = [true];
			}
		}
		
		// Controllo sovrapposizione tra mattino e pomeriggio
		if (this.enablePomeriggio && this.enableMattino && this.finishTimeMorning && this.startTimeAfternoon) {
			if (this.finishTimeMorning >= this.startTimeAfternoon) {
				this.finishTimeMorningRules = [
					"L'orario fine mattina non può essere uguale o successivo all'orario inizio pomeriggio"
				];
				this.startTimeAfternoonRules = [
					"L'orario inizio pomeriggio deve essere successivo all'orario fine mattina"
				];
			} else {
				// Reset delle regole se non c'è sovrapposizione
				if (this.finishTimeMorningRules[0] === "L'orario fine mattina non può essere uguale o successivo all'orario inizio pomeriggio") {
					this.finishTimeMorningRules = [true];
				}
				if (this.startTimeAfternoonRules[0] === "L'orario inizio pomeriggio deve essere successivo all'orario fine mattina") {
					this.startTimeAfternoonRules = [true];
				}
			}
		}
	}

	validazioneData() {
		if (this.date !== null && this.date !== "") {
			if (this.info && this.info.DataInizioPeriodo && this.info.DataFinePeriodo) {
				const selectedDate = new Date(this.dateTemp);
				const startPeriodoUno = new Date(this.info.DataInizioPeriodo);
				const endPeriodoUno = new Date(this.info.DataFinePeriodo);

				let isInValidPeriod = false;

				if (selectedDate >= startPeriodoUno && selectedDate <= endPeriodoUno) {
					isInValidPeriod = true;
				}

				if (this.info.DataInizioPeriodoDue && this.info.DataFinePeriodoDue) {
					const startPeriodoDue = new Date(this.info.DataInizioPeriodoDue);
					const endPeriodoDue = new Date(this.info.DataFinePeriodoDue);

					if (selectedDate >= startPeriodoDue && selectedDate <= endPeriodoDue) {
						isInValidPeriod = true;
					}
				}

				if (!isInValidPeriod) {
					const periodo1Text = `${this.formatDate(this.info.DataInizioPeriodo)} - ${this.formatDate(this.info.DataFinePeriodo)}`;
					let errorMessage = `La data deve rientrare nel periodo di attività: ${periodo1Text}`;

					if (this.info.DataInizioPeriodoDue && this.info.DataFinePeriodoDue) {
						const periodo2Text = `${this.formatDate(this.info.DataInizioPeriodoDue)} - ${this.formatDate(this.info.DataFinePeriodoDue)}`;
						errorMessage = `La data deve rientrare in uno dei periodi di attività: ${periodo1Text} o ${periodo2Text}`;
					}

					this.dateRules = [errorMessage];
					return;
				}
			}

			this.dateRules = [true];
		} else {
			this.dateRules = ["Data necessaria"];
		}
	}

	validazioneStartTimeMorning() {
		if (this.enableMattino) {
			if (this.startTimeMorning !== null && this.startTimeMorning !== "") {
				this.startTimeMorningRules = [true];
			} else {
				this.startTimeMorningRules = ["Orario inizio mattina necessario"];
			}
		} else {
			this.startTimeMorningRules = [true];
		}
	}

	validazioneFinishTimeMorning() {
		if (this.enableMattino) {
			if (this.finishTimeMorning !== null && this.finishTimeMorning !== "") {
				this.finishTimeMorningRules = [true];
			} else {
				this.finishTimeMorningRules = ["Orario fine mattina necessario"];
			}
		} else {
			this.finishTimeMorningRules = [true];
		}
	}

	validazioneStartTimeAfternoon() {
		if (this.enablePomeriggio) {
			if (this.startTimeAfternoon !== null && this.startTimeAfternoon !== "") {
				this.startTimeAfternoonRules = [true];
			} else {
				this.startTimeAfternoonRules = ["Orario inizio pomeriggio necessario"];
			}
		} else {
			this.startTimeAfternoonRules = [true];
		}
	}

	validazioneFinishTimeAfternoon() {
		if (this.enablePomeriggio) {
			if (this.finishTimeAfternoon !== null && this.finishTimeAfternoon !== "") {
				this.finishTimeAfternoonRules = [true];
			} else {
				this.finishTimeAfternoonRules = ["Orario fine pomeriggio necessario"];
			}
		} else {
			this.finishTimeAfternoonRules = [true];
		}
	}

	async executeValidation() {
		this.validazioneData();
		this.validazioneStartTimeMorning();
		this.validazioneFinishTimeMorning();
		this.validazioneStartTimeAfternoon();
		this.validazioneFinishTimeAfternoon();
		this.validazioneData();
		this.timeMorningValidation();
		this.timeAfternoonValidation();
	}	

	checkOreTot() {
		var timeStartMattino: any;
		var timeEndMattino: any;
		var timeStartPome: any;
		var timeEndPome: any;
		var oraInizioMattinoTmp: string;
		var oraFineMattinoTmp: string;
		var oraInizioPomeTmp: string;
		var oraFinePomeTmp: string;
		var oreMattino: any;
		var orePome: any;
		oraInizioMattinoTmp = this.startTimeMorning + ":00";
		oraFineMattinoTmp = this.finishTimeMorning + ":00";
		oraInizioPomeTmp = this.startTimeAfternoon + ":00";
		oraFinePomeTmp = this.finishTimeAfternoon + ":00";

		timeStartMattino = new Date("01/01/2000 " + oraInizioMattinoTmp)
		timeEndMattino = new Date("01/01/2000 " + oraFineMattinoTmp)
		timeStartPome = new Date("01/01/2000 " + oraInizioPomeTmp)
		timeEndPome = new Date("01/01/2000 " + oraFinePomeTmp)

		if (this.startTimeMorning !== null && this.finishTimeMorning !== '') {
			oreMattino = timeEndMattino - timeStartMattino;
		} else {
			oreMattino = 0;
		}

		if (this.startTimeAfternoon !== null && this.finishTimeAfternoon !== '') {
			orePome = timeEndPome - timeStartPome;
		} else {
			orePome = 0;
		}

		oreMattino = oreMattino / 60 / 60 / 1000;
		orePome = orePome / 60 / 60 / 1000;

		var truncateDecimals = function (number: any, digits: any) {
			var multiplier = Math.pow(10, digits),
				adjustedNum = number * multiplier,
				truncatedNum = Math[adjustedNum < 0 ? 'ceil' : 'floor'](adjustedNum);

			return truncatedNum / multiplier;
		}

		this.totOre = oreMattino + orePome;
		this.totOre = truncateDecimals(this.totOre, 1);
	}

	save() {
		if (
			this.startTimeMorning === null &&
			this.finishTimeMorning === null &&
			this.startTimeAfternoon === null &&
			this.finishTimeAfternoon === null
		) {
			bus.$emit("errorOperation", "Inserire almeno un orario");
		} else {
			this.executeValidation().then(() => {
				if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
					this.checkOreTot()
					if (this.totOre > 8) {
						bus.$emit("errorOperation", "Impossibile segnare più di 8 ore giornaliere");
					} else {
						var payload = {
							idRichiesta: this.params.idRichiesta,
							activityType: this.params.activityType,
							dataFirma: this.dateTemp,
							orarioInizioMattina: this.startTimeMorning,
							orarioFineMattina: this.finishTimeMorning,
							orarioInizioPomeriggio: this.startTimeAfternoon,
							orarioFinePomeriggio: this.finishTimeAfternoon
						};
						user
							.dispatchCreateGiornoFoglioFirme(this["$store"], payload)
							.then(() => {
								bus.$emit(
									"successfullOperation",
									"Nuova data creata con successo"
								);
								this.close();
								bus.$emit("loadFirme");
							})
							.catch(error => {
								if (error.response.status === 403) {
									bus.$emit("errorOperation", error.response.statusText);
									this["$router"].push("/login");
								} else {
									bus.$emit("errorOperation", error.response.statusText);
								}
							});
					}
				}
			});
		}
	}

	close() {
		// this.enablePomeriggio = false;
		// this.enableMattino = false;
		// this.date = "";
		// this.dateTemp = new Date().toISOString().substr(0, 10);
		// this.dateMenu = false;
		// this.startTimeMorning = null;
		// this.finishTimeMorning = null;
		// this.startTimeAfternoon = null;
		// this.finishTimeAfternoon = null;
		// this.finishTimeMenuMorning = false;
		// this.startTimeMenuMorning = false;
		// this.finishTimeMenuAfternoon = false;
		// this.startTimeMenuAfternoon = false;

		// this.dateRules = [true];
		// this.startTimeMorningRules = [true];
		// this.finishTimeMorningRules = [true];
		// this.startTimeAfternoonRules = [true];
		// this.finishTimeAfternoonRules = [true];
		// bus.$emit("closeCreateDialog");
		bus.$emit("loadFirme");
	}

	created() {
		this.dateFilter();
	}
}
